class Filter {
    constructor() {
        this.category = '';
        this.sort = '';
        this.status = '';
        this.page = 1;
        this.postType = '';
    }

    getActiveTerms() {
        this.category = this.getCategories();
        this.sort = this.getActiveSelectItem('sort');
        this.status = this.getActiveSelectItem('status');
        this.postType = this.getPostType();
    }

    getCategories() {
        const category = $('.filter__item.active').data('category');
        return category;
    }

    getActiveSelectItem(id) {
        const param = $(`#${id}`).val();
        return param;
    }

    getPostType() {
        const postType = $('#archive-results').data('post-type');
        return postType;
    }

    incrementPage(paged) {
        this.page = paged;
        this.search(true);
    }

    search(keepContent) {
        this.getActiveTerms();

        if (!keepContent) {
            this.page = 1
        }

        $.ajax({
            url: window.ajaxvars.ajax_url,
            type: 'post',
            data: {
                action: 'getunlocked_filter_posts',
                page: this.page,
                category: this.category,
                sort: this.sort,
                status: this.status,
                postType: this.postType,
            },
            beforeSend: () => {
                if( !keepContent ) {
                    $('#archive-results').empty();
                }
                $('.filter__pagination').remove();
                $('#archive-results').append('<div class="challenge__loader"></div>');
            },
            success: (data) => {
                $('#archive-results .challenge__loader').remove();
                $('#archive-results').append(data);
                $('.btn, .button').each( function() {
                    if( $(this).find('.btn__arrow').length == 0 ) {
                        $(this).prepend('<div class="btn__arrow"><i class="icon icon-arrow"></i></div>');
                    }
                });
            },
        });
    }
}

// Create a new filter intance
const filter = new Filter();

// Change events
$('.filter__item').on('click', function() {
    $('.filter__load-more').data('page', 1);
    $(this).addClass('active');
    $('.filter__item').not($(this)).each( function() {
        $(this).removeClass('active');
    })
    filter.search();
});

$('.filter__select').on('change', function() {
    filter.search();
});

$(document).on('click', '.filter__load-more', function() {
    const page = $(this).data('page') + 1;
    filter.incrementPage( page );
});

if ($('.filter__item--partner').length) {
    $('.filter__item--partner').trigger('click');
}
